import colors from '../TCP/colors';
import blue from '../colors/blue';
import green from '../colors/green';

const pjpColors = {
  ...colors,
  PJP_BLUE: blue[1200],
  PJP_TEAL: '#51b4bf',
  PJP_CORAL_ROSE: '#f37452',
  PJP_MERINO: '#f3eadc',
  PJP_GREEN: '#42bf79',
  PJP_RED: '#ba0a00',
  PJP_BABY_BLUE: '#b2d1e0',
  SEA_SWIMMER: '#327f86',
  PRIMARY_BUTTON_BORDER_COLOR: blue[1200],
  PRIMARY_BUTTON_COLOR: blue[1200],
  NOTIFICATION: {
    SUCCESS: '#327f86',
    ERROR: '#c8102e',
    ERROR_BACKGROUND: '#f4dcdc',
  },
  ORDER_STATUS_WRAPPER: blue[1200],
  ITEM_COUNT_WRAPPER: blue[1200],
  DIVIDER: '#D8D8D8',
  PLP_SIDEBAR_SUBCATEGORY_BORDER: green[800],
  PJP_HOVER: '#0133FF',
  PJP_CLICK: '#3850AF',
  TAP_TO_JOIN_BG_COLOR: blue[1200],
  BOSS_BOPIS_SHIPPING_CONTAINER: blue[1200],
  PLP_SIDE_NAVBAR_SUBHEADER_BORDER: green[800],
  NOTIFICATION_PROMPT_WRAPPER: '#51B4BF',
  NAVIGATION_BAR_SEMICIRCLE: '#DADADA',
  NAVIGATION_BAR_SEMICIRCLE_HOVER: '#56B5BE',
};

export default pjpColors;
